var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:_vm.cssClass,attrs:{"type":_vm.btnType,"variant":_vm.btnVariant},on:{"click":_vm.handleClick}},[(_vm.btnIcon != null)?_c('span',{staticClass:"btn-icon"},[_c('i',{class:_vm.btnIcon})]):_vm._e(),_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.btnLabel))]),_c('span',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }